import { createHandleChange } from "../../../utils/calculator/createHandleChange";
import { getInputWidth } from "../../../utils/calculator/getInputWidth";
import style from "../calculator.module.css";
function EditableTitleEvent(props) {
  const { formData, setFormData, statusMode } = props;
  const handleChange = createHandleChange(setFormData);
  return (
        <input

            type="text"
            name={"title"}
            placeholder={"Titulo do Evento..."}
            value={formData["title"]}
            onChange={handleChange}
            style={{
                minWidth: "250px",
                width: `${getInputWidth(formData["title"])}px`,
                maxWidth: '80vw',
                transition: 'width 0.2s ease',
            }}
            className={`fs-5 title-event align-self-center form-control ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}` : ""}  `}
        />
    );
}
export {
  EditableTitleEvent
};